import HeroImg from "../../components/heroimg/HeroImg";

const Home = () =>{
    return(
        <div>
            <HeroImg/>
        </div>
    )
}

export default Home;